import { getData, postData, putData } from 'helpers/apiHelper';
import { MAIN_PATH, TRASH_BIN_ITEM_VIEW, TRASH_BIN_LIST, TRASH_BIN_RESTORE } from './apiPath';
import { pickBy } from 'lodash';

export function getTrashBinList(value, callback) {
  const queryString = new URLSearchParams(pickBy(value)).toString();
  let url = `${MAIN_PATH}${TRASH_BIN_LIST}?${queryString}`;
  return getData(url, value);
}

export function restoreTrashBinItem(id, callback) {
  let url = `${MAIN_PATH}${TRASH_BIN_RESTORE}/${id}`;
  return postData(url);
}

export function viewTrashBinItem(id, callback) {
  let url = `${MAIN_PATH}${TRASH_BIN_ITEM_VIEW}/${id}`;
  return getData(url);
}